import { Messages as Message } from "../UI";
import { Notification } from 'element-ui'
import Clipboard from "clipboard";
import streamsaver from "streamsaver";
export function setToken(key, token) { // 设置存储token
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  addCookieAndDomain(key, token, 2, domain);
  if (localStorage) {
    localStorage.setItem(key, token);
  }
}
// 设置cookie token
function addCookieAndDomain(key, value, objHours, strdomain) {
  let str = key + '=' + value + ';domain=' + strdomain;
  if (objHours > 0) {
    let date = new Date();
    let ms = objHours * 3600 * 1000;
    date.setTime(date.getTime() + ms);
    str += ';expires=' + date.toGMTString() + ';path=/';
  } else {
    str += ';path=/';
  }
  document.cookie = str;
}


// 删除token
export function removeToken() {
  clearCookie();
  return localStorage.clear()
}
function clearCookie() {
  // eslint-disable-next-line no-useless-escape
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + ';domain=' + domain;
    }
  }
}

// 获取token
export function getToken(key) {
  return localStorage.getItem(key)
  // let cookieStr = document.cookie
  // if (cookieStr.length > 0) {
  //   let arrCookie = cookieStr.split("; ")
  //   for (const val of arrCookie) {
  //     let arr = val.split("=")
  //     if (arr[0] === key) {
  //       return arr[1]
  //     }
  //   }
  // }
  // return ""
}

// 设置cookie
export function setCookieVal(key, val, time = 2) {
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  addCookieAndDomain(key, val, time, domain);
}

// 获取cookie
export function getCookieVal(key) {
  let cookieStr = document.cookie

  if (cookieStr.length > 0) {
    let arrCookie = cookieStr.split("; ")

    for (const val of arrCookie) {
      let arr = val.split("=")
      if (arr[0] === key) {

        return arr[1]
      }
    }
  }
  return ""
}

/**
 * 下载文件
 * @param {String} url 下载地址
 * @param {String} filename 文件名
 */
export function downloadFile(url, filename, type, num) {
  window.log.singleLog("ai_download_all", { name: filename })
  if (url.includes('?')) {
    url += '&' + new Date().getTime()
  } else {
    url += '?' + new Date().getTime()
  }
  // url= url.includes('?') ? (url+'&'+new Date().getTime()):(url+'?'+new Date().getTime())
  fetch(url, { credentials: 'omit' })
    .then(response => response.blob())
    .then(blob => {

      let obj = {
        png: 'image/png',
        odd: 'application/vnd.oasis.opendocument.text',
        gif: 'image/gif',
        jpeg: 'image/jpeg',
        jpg: 'image/jpeg',
        bmp: 'image/bmp',
        svg: 'image/svg+xml',
        ico: 'image/x-icon',
        webp: 'image/webp',
        tiff: 'image/tiff', // TIFF 图像文件
        psd: 'image/vnd.adobe.photoshop', // Photoshop 文件
        pdf: 'application/pdf' // PDF 文件
      }
      !type ? type = 'png' : ''
      // 创建一个 Blob 对象，用于保存图片数据
      const file = new Blob([blob], { type: obj[type] });
      // 使用 FileSaver.js 保存文件
      saveAs(file, filename);
    })
    .catch(error => console.error('下载图片时出现错误：', error));
  if (num != 'Multiple') {
    let file = type == 'pdf' ? '文件' : '图片'
    Message({
      type: "success",
      message: `${file}正在下载中，下载成功后自动保存到本地，请稍后查看！`,
    })
  }
}

// 大文件下载
export function openDownload(url) {
  let ele = document.createElement('a');
  let urlStr = new URL(url)

  if (!urlStr.searchParams.get('attname')) {
    urlStr.searchParams.set('attname', '')
    url = urlStr.toString()
  }

  ele.setAttribute('href', url);
  ele.setAttribute('download', '');
  ele.setAttribute('target', '_blank');
  ele.style.display = 'none';
  document.body.appendChild(ele);
  ele.click();
  document.body.removeChild(ele);
}

/**
 * 大文件下载处理
 * @param {String} url 下载地址
 * @param {String} filename 文件名
 */
export function bigFileDownload(url, filename) {
  let format = url.split('.').pop()
  const fileStream = streamsaver.createWriteStream(`${filename}.${format}`);
  fetch(url).then(async res => {
    Notification({
      title: '提示',
      message: `文件正在下载中，请稍后...<i class="el-icon-loading"></i>`,
      dangerouslyUseHTMLString: true,
      duration: 0,
    })
    const readableStream = res.body
    if (window.WritableStream && readableStream.pipeTo) {
      return readableStream.pipeTo(fileStream).then(() => {
        Notification.closeAll()
        Notification({
          title: '提示',
          message: '下载成功，请到浏览器下载目录查看！',
          type: 'success'
        })
      })
    }
    window.writer = fileStream.getWriter()
    const reader = res.body.getReader()
    const pump = () => reader.read()
      .then(res => res.done
        ? window.writer.close()
        : window.writer.write(res.value).then(pump))
    pump()
  })
}

function addZero(num) {
  if (num < 10) {
    return '0' + num;
  } else {
    return num;
  }
}

/**
 * 获取当前时间
 * @param {String} type 类型 date 日期 time 时间
 * @returns {String} yyyy-MM-dd HH:mm:ss Or yyyy-MM-dd
 */
export function getCurTimeFormat(type) {
  let date = new Date();
  let year = date.getFullYear();
  let month = addZero(date.getMonth() + 1);
  let day = addZero(date.getDate());
  let hours = addZero(date.getHours());
  let minutes = addZero(date.getMinutes());
  let seconds = addZero(date.getSeconds());
  if (type === 'date') {
    return year + '-' + month + '-' + day;
  }
  let curTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return curTime;
}

/**
 * 时间戳转日期
 * @param {Number} timestamp 时间戳
 * @param {String} type 类型 date 日期 time 时间
 * @returns {String} yyyy-MM-dd HH:mm:ss Or yyyy-MM-dd
 */
export function timestampFormat(timestamp, type) {
  let date = new Date(timestamp);
  let year = date.getFullYear();
  let month = addZero(date.getMonth() + 1);
  let day = addZero(date.getDate());
  let hours = addZero(date.getHours());
  let minutes = addZero(date.getMinutes());
  let seconds = addZero(date.getSeconds());
  if (type === 'date') {
    return year + '-' + month + '-' + day;
  }
  let curTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return curTime;
}

/**
 * 左右平滑滚动
 * @param {Element} container 滚动容器
 * @param {Number} scrollAmount 滚动距离
 * @param {Number} duration 滚动时间
 */
export function smoothScroll(container, scrollAmount, duration) {
  const start = container.scrollLeft;
  const target = start + scrollAmount;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1); // 计算进度

    // 使用缓动函数生成平滑效果
    const ease = progress * (2 - progress);
    container.scrollLeft = start + (target - start) * ease;

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}

/**
 * 判断容器是否滚动到底部
 * @param {Element} container 滚动容器
 * @param {Number} threshold 阈值（可选，默认为0）
 * @returns {Boolean} 是否滚动到底部
 */
export function isScrollBottom(container, threshold = 0) {
  // 获取容器的滚动高度、可见高度和内容高度
  const scrollHeight = container.scrollHeight; // 内容总高度
  const clientHeight = container.clientHeight; // 可视区域高度
  const scrollTop = container.scrollTop; // 当前滚动距离

  // 判断是否滚动到底部，加上阈值
  return scrollTop + clientHeight >= scrollHeight - threshold;
}

/**
 * 防抖函数
 * @param {Function} fn 要防抖的函数
 * @param {Number} delay 延迟时间（毫秒）
 * @returns {Function} 返回一个防抖处理后的函数
 */
export function debounce(fn, delay) {
  let timer = null;

  return function (...args) {
    // 清除上一个定时器
    if (timer) {
      clearTimeout(timer);
    }
    // 设置新的定时器
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

/**
 * 滚动到指定位置或元素
 * @param {HTMLElement} container - 滚动容器
 * @param {HTMLElement|number} target - 目标元素或目标距离（竖向滚动为 top，横向滚动为 left）
 * @param {boolean} isHorizontal - 是否横向滚动（默认竖向滚动）
 * @param {number} offset - 额外的偏移量（默认为 0）
 * @param {boolean} smooth - 是否平滑滚动（默认为 true）
 */
export function smoothScrollView(container, target, isHorizontal = false, offset = 0, smooth = true) {
  // 确保容器是一个有效的 DOM 元素
  if (!(container instanceof HTMLElement)) {
    console.error("Container must be a valid DOM element.");
    return;
  }

  let scrollPosition;

  if (typeof target === "number") {
    // 如果目标是数字，直接使用该值作为滚动位置
    scrollPosition = target;
  } else if (target instanceof HTMLElement) {
    // 如果目标是元素，计算其相对于容器的位置
    const containerRect = container.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();

    if (isHorizontal) {
      scrollPosition = targetRect.left - containerRect.left + container.scrollLeft;
    } else {
      scrollPosition = targetRect.top - containerRect.top + container.scrollTop;
    }
  } else {
    console.error("Target must be a valid DOM element or a number.");
    return;
  }
  // 添加额外的偏移量
  scrollPosition += offset;

  // 执行滚动
  if (isHorizontal) {
    container.scrollTo({
      left: scrollPosition,
      behavior: smooth ? "smooth" : "auto",
    });
  } else {
    container.scrollTo({
      top: scrollPosition,
      behavior: smooth ? "smooth" : "auto",
    });
  }
}

export function copyText(text, e) {
  const clipboard = new Clipboard(e.target, {
    text: () => text
  });
  clipboard.on("success", () => {
    Message({
      type: "success",
      message: "复制文本成功"
    });
    // 释放内存
    clipboard.destroy();
  });
  clipboard.on("error", () => {
    // 不支持复制
    Message({
      type: "warning",
      message: "该浏览器不支持自动复制"
    });
    // 释放内存
    clipboard.destroy();
  });
  // 解决第一次点击不生效的问题，如果没有，第一次点击会不生效
  clipboard.onClick(e);
}

/**
 * 根据时间返回日期范围
 * @param {string} dateString 日期字符串
 * @returns {string}
 */
export function dateRangeCheck(dateString) {
  // 将传入的字符串转换为 Date 对象
  const inputDate = new Date(dateString);
  const today = new Date();

  // 获取今天的年、月、日，并设置时间为0
  const startOfToday = new Date(today);
  startOfToday.setHours(0, 0, 0, 0);

  // 获取明天的开始时间
  const startOfTomorrow = new Date(today);
  startOfTomorrow.setDate(today.getDate() + 1);
  startOfTomorrow.setHours(0, 0, 0, 0);

  // 近7天和近30天的日期边界
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);

  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(today.getDate() - 30);

  // 判断输入的日期在哪个范围内
  if (inputDate >= startOfToday && inputDate < startOfTomorrow) {
    return "今天";
  } else if (inputDate >= sevenDaysAgo && inputDate < startOfToday) {
    return "近7天";
  } else if (inputDate >= thirtyDaysAgo && inputDate < sevenDaysAgo) {
    return "近30天";
  } else {
    return "以前";
  }
}

/**
 * 文件地址中获取文件格式
 * @param {String} url 文件地址
 * @returns {String}
 */
export function getFileFormat(url) {
  const format = url.split('.').pop()
  return format.toLowerCase()
}

// 根据size返回相应单位的大小
export function formatFileSize(size) {
  if (size < 1024) {
    return size + ' B';
  } else if (size < 1024 * 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  } else if (size < 1024 * 1024 * 1024) {
    return (size / (1024 * 1024)).toFixed(2) + ' MB';
  } else {
    return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
  }
}

/**
 * 时间格式转换
 * @param {String} dateString 日期字符串 2025-07-24T16:56:27.755+08:00
 * @returns {String} 返回格式化后的日期字符串
 */
export function formatDate(dateString, isDay = true) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = addZero(date.getMonth() + 1);
  const day = addZero(date.getDate());
  if (isDay) {
    return year + "-" + month + "-" + day;
  }
  const hours = addZero(date.getHours());
  const minutes = addZero(date.getMinutes());
  const seconds = addZero(date.getSeconds());
  const formatDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
  return formatDate;
}

/**
 * 根据传入时间判断是多久前，几年前，几月前，几天前，几小时前，几分钟前，几秒前，
 * @param {String} dateString 日期字符串
 * @returns {String} 返回几xx前
 */
export function timeAgo(dateString) {
  if (!dateString) {
    return "-"
  }
  const date = new Date(dateString);
  const now = new Date();
  const diff = now - date;

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  if (years > 0) {
    return `${years}年前`;
  } else if (months > 0) {
    return `${months}月前`;
  } else if (days > 0) {
    return `${days}天前`;
  } else if (hours > 0) {
    return `${hours}小时前`;
  } else if (minutes > 0) {
    return `${minutes}分钟前`;
  } else {
    return `${seconds}秒前`;
  }
}

/**
 * 根据日期字符串返回月日
 * @param {String} dateString 日期字符串
 * @returns {String} 返回月日
 */
export function getMonthDay(dateString) {
  if (!dateString) {
    return "-"
  }
  const date = new Date(dateString);
  const month = addZero(date.getMonth() + 1);
  const day = addZero(date.getDate());
  return `${month}-${day}`;
}

// 文件大小计算使用适合的单位
export function fileSize(size) {
  if (size === null || size === "" || size <= 0) {
    return "0 Bytes";
  }
  let unitArr = ["Bytes", "KB", "MB", "G", "TB", "PB", "EB", "ZB", "YB"];
  let index = 0
  index = Math.floor(Math.log(size) / Math.log(1024));
  let fileSize = size / Math.pow(1024, index);
  fileSize = Math.round(fileSize * 10) / 10;
  return fileSize + unitArr[index];
}

// 文件格式展示
export function formatIcon(fileFormat) {
  let iconName = "";
  switch (fileFormat) {
    case "xls":
    case "xlsx":
      iconName = "excel";
      break;
    case "doc":
    case "docx":
      iconName = "word";
      break;
    case "ppt":
    case "pptx":
      iconName = "ppt";
      break;
    case "pdf":
    case "txt":
    case "zip":
    case "psd":
    case "mp3":
      iconName = fileFormat;
      break;
    case "rar":
      iconName = "zip";
      break;
    case "mp4":
    case "avi":
    case "wmv":
      iconName = "video";
      break;
    default:
      iconName = "no";
      break;
  }
  let imgUrl = require(`../assets/fileIcon/${iconName}.png`);
  return imgUrl;
}